module.exports = __webpack_public_path__ + "fonts/iconfont.f484c6af.woff";